<template>
    <div>
        <div class="message">
            <img :src="msg.sender_avatar" :alt="msg.sender_name" width="50" height="50"
                 style="float: left; margin-right: 5px;"/>
            <strong>{{ msg.sender_name }}</strong> has posted a comment in the<span
            v-if="msg.conversation_group_name">&nbsp;<strong>{{ msg.conversation_group_name }}</strong> Group</span>
            Conversation <strong>{{ msg.conversation_name }}</strong>.
        </div>
        <div class="message" v-if="msg.text">
            <i>{{ $cutName(msg.text, 60) }}</i>
        </div>
        <div class="message" style="margin-top: 5px;">
            <a :href="msg.conversation_link" class="btn btn-small btn-primary">Open Conversation</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WsNewConversationMessageNotification",
        props: {
            msg: {
                type: Object,
                required: true
            }
        }
    };
</script>
